import React, { useEffect, useState } from 'react'
import MainContent from 'src/components/layouts/MainContent'
import MainMenu from 'src/components/layouts/MainMenu'
import PowerBIReport from 'src/components/PowerBI/PowerBIReport'
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button, Box } from '@mui/material'
import { ArrowLeftIcon } from '@rsmus/myrsm-icons'
import { useSelector } from 'react-redux'
import { Styles } from '../../types'
import api from '../../api'
import tokens from '../../styles/tokens.json'
import Spinner from '../../components/forms/Spinner'
import { useDeviceType } from '../../rsmCoreComponents/hooks/useDeviceType'
import { getReportData } from '../../store/powerBI/reportSlice'

const styles: Styles = {
  wrapper: { position: 'relative' },
  section: (theme) => ({
    backgroundColor: tokens.colors.white,
    padding: '0.5rem 6.5rem',
    [theme.breakpoints.only('mobile')]: {
      padding: '0.5rem 1rem',
    },
    [theme.breakpoints.only('tablet')]: {
      padding: '0.5rem 2rem',
    },
  }),
  header: (theme) => ({
    fontFamily: 'Prelo-Light, sans-serif',
    fontSize: '2.25rem',
    lineHeight: '3.5rem',
    color: theme.palette.text.primary,
    paddingBottom: ' 1.5rem',
  }),
  backButton: (theme) => ({
    color: theme.palette.secondary.main,
    padding: 0,
  }),
  link: {
    textDecoration: 'underline',
    padding: '0 0.5rem',
    fontSize: '1rem',
  },
}

const Report = () => {
  const { reportName } = useParams()
  const { isMobile } = useDeviceType()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const reportData = useSelector(getReportData)
  const [displayName, setDisplayName] = useState<string>('')

  async function getReportDisplayName() {
    try {
      const response = await api.user.report_GetReportDisplayName(reportName)
      if (response && response.data) {
        setDisplayName(response.data)
      }
    } catch (error) {
      console.error('Failed to fetch report display name:', error)
      setDisplayName('')
    }
  }

  useEffect(() => {
    getReportDisplayName()
  }, [])

  return (
    <Box>
      {isMobile && !reportData.hasAdminRole ? (
        <>
          <Spinner open={isMobile} />
          <PowerBIReport
            reportName={reportName}
            onReportDisplayNameChange={setDisplayName}
          />
        </>
      ) : (
        <>
          <MainMenu currentItem="report" />
          <Box sx={styles.wrapper}>
            <Box sx={styles.section}>
              <Button
                data-testid="Btn_Report_Back"
                onClick={() => navigate('/')}
                sx={styles.backButton}
                role="link">
                <ArrowLeftIcon />
                <Box component="span" sx={styles.link}>
                  {t('PowerBI.Report.Back')}
                </Box>
              </Button>
              <MainContent>
                <Box
                  component={'h1' as React.ElementType}
                  sx={styles.header}
                  title={displayName}
                  data-testid={`Hed_Report_${displayName}`}>
                  {displayName}
                </Box>
                <PowerBIReport
                  reportName={reportName}
                  onReportDisplayNameChange={setDisplayName}
                />
              </MainContent>
            </Box>
          </Box>
        </>
      )}
    </Box>
  )
}

export default Report
